module.exports = __webpack_public_path__ + "img/consult_info2.158462dc.png";